import React from 'react';

export const Move = ({
  className,
  color,
  height,
  width,
}: {
  className?: string;
  color?: string;
  height?: string;
  width?: string;
}) => (
  <svg
    width={width || '20'}
    height={height || '21'}
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.16306 11.1977L6.16306 3.62228L7.82973 3.62228L7.82973 11.1977H6.16306Z"
      fill={color || '#6E6B8C'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.837 7.21543L13.837 15.8697L12.1703 15.8697L12.1703 7.21543L13.837 7.21543Z"
      fill={color || '#6E6B8C'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.9964 4.70069L4.58205 7.11503L3.40354 5.93652L6.9964 2.34367L10.5893 5.93652L9.41075 7.11503L6.9964 4.70069Z"
      fill={color || '#6E6B8C'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.0036 14.6912L10.5893 12.2768L9.41077 13.4553L13.0036 17.0482L16.5965 13.4553L15.418 12.2768L13.0036 14.6912Z"
      fill={color || '#6E6B8C'}
    />
  </svg>
);
